// extracted by mini-css-extract-plugin
module.exports = {"column":"AprraisedValue_column__1thtH","row":"AprraisedValue_row__YbVJb","value":"AprraisedValue_value__1Lbgt","strike":"AprraisedValue_strike__MWx28"};